if ($.validator && $.validator.unobtrusive) {
	$.validator.unobtrusive.adapters.addSingleVal("confirmpaymentmethodterms", "paymentmethodtype");

	$.validator.addMethod("confirmpaymentmethodterms", function (value, element, paymentmethodtype) {
		var $paymentmethodtype = $('#' + paymentmethodtype);
		if ($paymentmethodtype.val() == "ACH" && !$(element).is(":checked")) {
			return false;
		}
		return true;
	});
}
